<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: 'welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>团队管理</el-breadcrumb-item>
      <el-breadcrumb-item>员工列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>
        <!-- 搜索栏和添加员工 -->
        <div class="search-wrapper">
          <div class="search-toggle" @click="toggleSearch" v-show="isMobile">
            <i :class="isSearchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            <span>{{ isSearchExpanded ? '收起筛选' : '展开筛选' }}</span>
          </div>
          <div class="search-content" v-show="!isMobile || isSearchExpanded" :class="{ 'search-content-mobile': isMobile }">
            <el-row :gutter="20" style="margin-bottom: 10px">
              <el-col :span="6">
                <el-input
                  placeholder="请输入用户名"
                  v-model="searchUsername"
                  clearable
                  @clear="handleSearch()"
                  @keyup.enter.native="handleSearch()"
                  size="medium"
                >
                  <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
                </el-input>
              </el-col>
              <el-col :span="6">
                <el-input
                  placeholder="请输入手机号"
                  v-model="searchPhone"
                  clearable
                  @clear="handleSearch()"
                  @keyup.enter.native="handleSearch()"
                  size="medium"
                >
                  <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
                </el-input>
              </el-col>
              <el-col :span="4">
                <el-select
                  v-model="searchRole"
                  placeholder="请选择角色"
                  clearable
                  size="medium"
                  style="width: 100%;"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="role in roleList"
                    :key="role.id"
                    :label="role.name"
                    :value="role.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" size="medium" icon="el-icon-plus" @click="showAddBox = true">创建员工</el-button>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 员工列表 -->
        <div class="table-scroll-wrapper">
          <el-table :data="userList" style="width: 100%" border stripe>
            <el-table-column label='#' type='index' align="center"></el-table-column>
            <el-table-column label='用户名' prop='username' align="center"></el-table-column>
            <el-table-column label='手机号' prop='phone' align="center"></el-table-column>
            <el-table-column label='角色' width="120px" align="center">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.role === 1 ? 'danger' : (scope.row.role === 2 ? 'primary' : 'success')">
                        {{getRole(scope.row.role)}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label='状态' width='80px' align="center">
                <template v-slot='scope'>
                    <el-switch v-model="scope.row.is_active" @change="toggleState(scope.row.id, scope.row.is_active)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label='上次登录' align="center">
                <template v-slot='scope'>
                    {{dataFormat(scope.row.last_login_time)}}
                </template>
            </el-table-column>
            <el-table-column label='登录IP' align="center">
                <template v-slot="scope">
                    <div v-if="scope.row.last_login_ip">
                        <el-tooltip 
                            effect="dark" 
                            :content="scope.row.last_login_ip" 
                            placement="top"
                        >
                            <span>{{ scope.row.last_login_ip_location || '-' }}</span>
                        </el-tooltip>
                    </div>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label='操作' width='200px' align="center">
                <template v-slot='scope'>
                    <el-tooltip effect="dark" content="编辑" placement="top" :enterable='false'>
                        <el-button type="primary" icon="el-icon-edit" size='mini' @click="editUser(scope.row.id)"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top" :enterable='false'>
                        <el-button type="danger" icon="el-icon-delete" size='mini' @click="deleteUser(scope.row.id)"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="分配角色" placement="top" :enterable='false'>
                        <el-button type="warning" icon="el-icon-setting" size='mini' @click="setRole(scope.row)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
          </div>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <el-pagination
              @size-change="onSizeChange"
              @current-change="onPageChange"
              :current-page="pageNum"
              :page-sizes="[1, 2, 5, 10]"
              :page-size="pageSize"
              :layout="isMobile ? 'total, sizes, prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
              :total="total">
          </el-pagination>
        </div>
    </el-card>

    <!-- 创建员工对话框 -->
    <el-dialog title="创建员工" :visible.sync="showAddBox" width="30%" @close="resetAddForm()">
        <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
            <el-form-item label="用户名" prop="username">
                <el-input v-model="addForm.username"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="addForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input v-model="addForm.password"></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="role">
                <el-select v-model="addForm.role" placeholder="请选择角色" style="width: 100%;">
                    <el-option 
                        v-for="item in roleList.filter(r => r.id !== 1)" 
                        :key="item.id" 
                        :label="item.name" 
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="addForm.role === 6" label="带队活动" prop="activity_ids">
                <el-select v-model="addForm.activity_ids" multiple filterable placeholder="请选择带队活动" style="width: 100%">
                    <el-option v-for="activity in activityOptions" :key="activity.activity_id" :label="activity.title_cn" :value="activity.activity_id" />
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="showAddBox = false">取 消</el-button>
            <el-button type="primary" @click="addUser">确 定</el-button>
        </span>
    </el-dialog>

    <!-- 修改员工对话框 -->
    <el-dialog title="修改员工" :visible.sync="showEditBox" width="30%" @close="resetEditForm()">
        <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="90px">
            <el-form-item label="员工ID" prop="id">
                <el-input v-model="editForm.id" disabled></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="username">
                <el-input v-model="editForm.username"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="editForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="password">
                <el-input v-model="editForm.password"></el-input>
            </el-form-item>
            <el-form-item v-if="editForm.role === 6" label="带队活动" prop="activity_ids">
                <el-select v-model="editForm.activity_ids" multiple filterable placeholder="请选择带队活动" style="width: 100%">
                    <el-option v-for="activity in activityOptions" :key="activity.activity_id" :label="activity.title_cn" :value="activity.activity_id" />
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="showEditBox = false">取 消</el-button>
            <el-button type="primary" @click="updateUser">确 定</el-button>
        </span>
    </el-dialog>

    <!-- 更新角色对话框 -->
    <el-dialog title="更新角色" :visible.sync="showRoleBox" width="30%" @close="resetRoleForm()">
        <div>
            <p>用户名称：<el-tag type="info">{{userInfo.username}}</el-tag></p>
            <p>当前角色：<el-tag type="info">{{getRole(userInfo.role)}}</el-tag></p>
            <p>新配角色：
                <el-select v-model="newRole" placeholder="请选择新角色">
                    <el-option 
                        v-for="item in roleList.filter(r => r.id !== 1)" 
                        :key="item.id" 
                        :label="item.name" 
                        :value="item.id">
                    </el-option>
                </el-select>
            </p>
            <div v-if="newRole === 6" style="margin-top: 16px;">
                <p>新配角色：
                    <el-select v-model="roleForm.activity_ids" multiple filterable placeholder="请选择带队活动" style="width: 80%">
                        <el-option v-for="activity in activityOptions" :key="activity.activity_id" :label="activity.title_cn" :value="activity.activity_id" />
                    </el-select>
                </p>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="showRoleBox = false">取 消</el-button>
            <el-button type="primary" @click="updateRole(userInfo.id)">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import { validateFormPhone } from '@/utils/validation'

export default {
  name: "Users",
  data(){
    return {
        isSearchExpanded: false,
        isMobile: false,
        userList: [],
        showAddBox: false,
        showEditBox: false,
        showRoleBox: false,
        addForm: {
            username: '',
            phone: '',
            role: null,
            password: null,
            is_active: true,
            activity_ids: []
        },
        editForm: {
            id: null,
            username: '',
            phone: '',
            password: null,
            role: null,
            activity_ids: []
        },
        addFormRules: {
            username: [
                { required: true, message: '请输入用户名', trigger: 'blur' },
                { min: 3, max: 10, message: '长度在3到10个字符', trigger: 'blur' }
            ],
            phone: [
                { required: true, message: '请输入手机号', trigger: 'blur' },
                { validator: validateFormPhone, trigger: 'blur'}
            ],
            password: [
                { required: true, message: '请设置新密码', trigger: 'blur' },
                { min: 8, max: 15, message: '长度在8到15个字符', trigger: 'blur' }
            ],
            role: [
                { required: true, message: '请选择角色', trigger: 'blur' }
            ],
            activity_ids: [
                { required: true, type: 'array', min: 1, message: '请选择至少一个活动', trigger: 'change' }
            ]
        },
        editFormRules: {
            username: [
                { required: true, message: '请输入用户名', trigger: 'blur' },
                { min: 3, max: 10, message: '长度在3到10个字符',trigger: 'blur' }
            ],
            phone: [
                { required: true, message: '请输入手机号', trigger: 'blur' },
                { validator: validateFormPhone, trigger: 'blur'}
            ],
            password: [
                { required: false, min: 8, max: 15, message: '长度在8到15个字符', trigger: 'blur' }
            ],
            role: [
                { required: true, message: '请选择角色', trigger: 'blur' }
            ],
            activity_ids: [
                { required: true, type: 'array', min: 1, message: '请选择至少一个活动', trigger: 'change' }
            ]
        },
        newRole: '',
        userInfo: {},
        roleList: [
            { id: 1, name: '超级管理员' },
            { id: 2, name: '管理员' },
            { id: 3, name: '运营' },
            { id: 4, name: '客服' },
            { id: 5, name: '财务' },
            { id: 6, name: '带队老师' }
        ],
        total: 0,
        pageNum: 1,
        pageSize: 10,
        activityOptions: [], // 新增
        roleForm: {
            activity_ids: []
        },
        // 搜索相关
        searchUsername: '',
        searchPhone: '',
        searchRole: null
    }
  },
  created(){
      this.fetchUsers()
      this.checkIsMobile()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    fetchUsers() {
      const params = {
        page: this.pageNum,
        size: this.pageSize
      }
      if (this.searchUsername) {
        params.username = this.searchUsername
      }
      if (this.searchPhone) {
        params.phone = this.searchPhone
      }
      if (this.searchRole !== null && this.searchRole !== '') {
        params.role = this.searchRole
      }
      this.$http({ method: 'get', url: 'users', params })
        .then(res => {
          if(!res.success) return this.$message.error(res.message)
          this.userList = res.data
          this.total = res.total
        })
        .catch(err => {
          this.$message.error(err.response?.data?.message || '获取员工列表失败')
        })
    },
    async fetchActivities() {
      try {
        const res = await this.$http({ method: 'get', url: 'activities/search', params: { page: 1, size: 1000 } })
        this.activityOptions = res.data || []
      } catch (err) {
        this.$message.error('获取活动列表失败')
      }
    },
    dataFormat(originVal){
        const dt = new Date(originVal)
        const y = dt.getFullYear()
        const m = (dt.getMonth() + 1 + '').padStart(2, '0')
        const d = (dt.getDate() + '').padStart(2, '0')
        const hh = (dt.getHours() + '').padStart(2, '0')
        const mm = (dt.getMinutes() + '').padStart(2, '0')
        const ss = (dt.getSeconds() + '').padStart(2, '0')
        return `${y}/${m}/${d} ${hh}:${mm}:${ss}`
    },
    onSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchUsers()
    },
    onPageChange(newPage) {
      this.pageNum = newPage 
      this.fetchUsers()
    },
    handleSearch() {
      this.pageNum = 1
      this.fetchUsers()
    },
    addUser(){
        this.$refs.addFormRef.validate(valid => {
            if(!valid) return
            const data = { ...this.addForm }
            if (data.role !== 6) delete data.activity_ids
            this.$http({ method: 'post', url: 'users', data }).then(res => {
                if(!res.success) return this.$message.error(res.message)
                this.$message.success('创建员工成功')
                this.showAddBox = false
                this.fetchUsers()
            }).catch(err => {
                this.$message.error(err.response?.data?.message || '创建员工失败')
            })
        })
    },
    resetAddForm() {
      this.$refs.addFormRef.resetFields()
    },
    editUser: async function(id) {
      await this.fetchActivities();
      this.$http({ method: 'get', url: 'users/' + id })
        .then(res => {
          if(!res.success) return this.$message.error(res.message)
          this.editForm = {
            id: res.data.id,
            username: res.data.username,
            phone: res.data.phone,
            password: null,
            role: res.data.role,
            activity_ids: res.data.activity_ids || []
          }
          this.showEditBox = true
        })
        .catch(err => {
          this.$message.error(err.response?.data?.message || '获取员工信息失败')
        })
    },
    updateUser() {
      this.$refs.editFormRef.validate(valid => {
        if(!valid) return
        const data = {
            username: this.editForm.username,
            phone: this.editForm.phone,
            password: this.editForm.password,
            role: this.editForm.role
        }
        if (this.editForm.role === 6) {
          data.activity_ids = this.editForm.activity_ids
        }
        this.$http({
            method: 'patch',
            url: 'users/' + this.editForm.id,
            data
        })
          .then(res => {
            if(!res.success) return this.$message.error(res.message)
            this.$message.success('修改员工信息成功')
            this.showEditBox = false
            this.fetchUsers()
          })
          .catch(err => {
            this.$message.error(err.response?.data?.message || '修改员工信息失败')
          })
      })
    },
    resetEditForm() {
      this.$refs.editFormRef.resetFields()
    },
    toggleState(id, state) {
      this.$http({ method: 'patch', url: `users/${id}`, data: {is_active: state} })
        .then(res => {
          if(!res.success) return this.$message.error(res.message)
        })
        .catch(err => {
          this.$message.error(err.response?.data?.message || '更新员工状态失败')
          this.fetchUsers()
        })
    },
    deleteUser(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete('users/' + id)
          .then(res => {
            if(!res.success) return this.$message.error(res.message)
            this.$message.success('删除员工成功')
            this.fetchUsers()
          })
          .catch(err => {
            this.$message.error(err.response?.data?.message || '删除员工失败')
          })
      }).catch((err) => err)
    },
    getRole(roleId) {
        const role = this.roleList.find(r => r.id === roleId)
        return role ? role.name : '未知角色'
    },
    setRole(userInfo){
        this.userInfo = userInfo
        this.showRoleBox = true
    },
    updateRole(id) {
      if(this.newRole === 6) {
        if(!this.roleForm.activity_ids || this.roleForm.activity_ids.length === 0) {
          this.$message.error('请选择至少一个活动')
          return
        }
        this.$http({ method: 'patch', url: `users/${id}`, data: { role: this.newRole, activity_ids: this.roleForm.activity_ids } })
        .then(res => {
            if(!res.success) return this.$message.error(res.message)
            this.fetchUsers()
            this.showRoleBox = false
            this.$message.success('更新角色成功')
        })
        .catch(err => {
            this.$message.error(err.response?.data?.message || '更新角色失败')
        })
      } else {
        this.$http({ method: 'patch', url: `users/${id}`, data: { role: this.newRole } })
          .then(res => {
            if(!res.success) return this.$message.error(res.message)
            this.fetchUsers()
            this.showRoleBox = false
            this.$message.success('更新角色成功')
          })
          .catch(err => {
            this.$message.error(err.response?.data?.message || '更新角色失败')
          })
      }
    },
    resetRoleForm() {
      this.newRole = ''
      this.userInfo = {}
    },

    toggleSearch() {
      this.isSearchExpanded = !this.isSearchExpanded
    },
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    handleResize() {
      this.checkIsMobile()
    }
  },
  watch: {
    showAddBox(val) {
      if (val) this.fetchActivities()
    },
    showRoleBox(val) {
      if (val) {
        this.fetchActivities()
        // this.roleForm.activity_ids = []
      }
    },
    showEditBox(val) {
      if (val) this.fetchActivities();
    }
  }
}
</script>

<style scoped>
.search-wrapper {
  margin-bottom: 10px;
}

.search-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.3s;
}

.search-toggle:hover {
  color: #409eff;
}

.search-toggle i {
  font-size: 14px;
}

.search-content {
  padding-top: 10px;
}

.search-content-mobile {
  padding-top: 10px;
}

.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-scroll-wrapper .el-table {
  min-width: 100%;
}

.pagination-wrapper {
  margin-top: 15px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
}

.pagination-wrapper .el-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 10px 0;
  min-width: max-content;
}

@media (max-width: 768px) {
  .el-card {
    margin-top: 10px;
    padding: 10px;
  }

  .table-scroll-wrapper .el-table {
    font-size: 11px;
  }

  .table-scroll-wrapper .el-table th,
  .table-scroll-wrapper .el-table td {
    padding: 8px 5px !important;
  }

  .pagination-wrapper {
    margin-top: 10px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
  }

  .pagination-wrapper .el-pagination {
    font-size: 10px;
    justify-content: flex-start;
    min-width: max-content;
  }

  .pagination-wrapper .btn-prev,
  .pagination-wrapper .btn-next {
    width: 26px;
    height: 26px;
    line-height: 26px;
    font-size: 11px;
    padding: 0;
  }

  .pagination-wrapper .el-pager li {
    padding: 0 2px;
    min-width: 22px;
    height: 26px;
    line-height: 26px;
    font-size: 10px;
  }

  .pagination-wrapper .el-pagination__total {
    font-size: 10px;
    margin-right: 8px;
  }

  .pagination-wrapper .el-pagination__sizes {
    margin-right: 8px;
  }

  .pagination-wrapper .el-pagination__sizes .el-input {
    width: 60px;
  }

  .pagination-wrapper .el-pagination__sizes .el-input__inner {
    height: 24px;
    font-size: 10px;
    padding: 0 5px;
  }

  .search-content .el-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .search-content .el-row .el-col {
    width: 100% !important;
    margin-bottom: 5px;
  }

  .search-toggle {
    padding: 10px 0;
    font-size: 13px;
  }

  .el-dialog {
    width: 90% !important;
    margin: 0 auto;
  }

  .el-dialog .el-form-item__label {
    font-size: 13px;
  }

  .el-dialog .el-input__inner {
    height: 38px;
    font-size: 13px;
  }
}
</style>